// @ts-nocheck
document.querySelectorAll('.modal-wrapper').forEach(e => {
  let openTrigger = e.querySelector('.modal_open')
  let closeTrigger = e.querySelector('.modal_close')
  let modal = e.querySelector('.modal')
  let video = e.querySelector('#video')

  const stopVideo = () => {
    if (video) {
      video.contentWindow.postMessage(
        JSON.stringify({
          type: 'player:pause',
          data: {}
        }),
        '*'
      )
      video.contentWindow.postMessage(
        JSON.stringify({
          type: 'player:remove',
          data: {}
        }),
        '*'
      )
    }
  }
  const playVideo = () => {
    if (video) {
      video.contentWindow.postMessage(
        JSON.stringify({
          type: 'player:play',
          data: {}
        }),
        '*'
      )
    }
  }
  openTrigger?.addEventListener('click', function (e) {
    e.preventDefault()
    modal.classList.add('show')
    playVideo()
  })
  closeTrigger?.addEventListener('click', function (e) {
    e.preventDefault()
    stopVideo()
    modal.classList.remove('show')
  })
  //слушатель, чтоб закрыть на esc
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.code === 27) {
      e.preventDefault()
      stopVideo()
      modal.classList.remove('show')
    }
  })
})
